import styled from "styled-components";
import { Button } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const Header = styled(FlexRow)`
    justify-content: center;
    margin-bottom: 10px;
`;

export const Title = styled.h1`
    margin: 0;
    ${setFontVariant("h4", colorsPalettes.carbon[500])};
`;

export const ImageContainer = styled(FlexRow)`
    justify-content: center;
`;

export const Footer = styled(FlexRow)`
    justify-content: center;
    margin-top: 8px;
`;

export const CloseButton = styled(Button)`
    ${setFontVariant("button", colorsPalettes.carbon[0])};
    justify-content: center;
`;
